import { TimelineLite } from 'gsap';

class InstagramFeed {

    constructor() {
        this.post = null;
        this.tl = null;
        this.modal = {
            container: document.querySelector('.instagram-modal'),
            dimmer: document.querySelector('.instagram-modal .dimmer'),
            content: {
                container: document.querySelector('.instagram-modal .content'),
                image: document.querySelector('.instagram-modal .content .image > img'),
                avatar: document.querySelector('.instagram-modal .content .author .avatar > img'),
                author: document.querySelector('.instagram-modal .content .author .name'),
                post: document.querySelector('.instagram-modal .content .post'),
            },
            closeButton: document.querySelector('.instagram-modal .close-button'),
        };
        this.timeline();
        this.activateListeners();
    }

    timeline() {
        this.tl = new TimelineLite({
            paused: true,
            onReverseComplete: this.removeContent,
            onReverseCompleteScope: this,
        })
            .call( () => {
                this.modal.container.classList.toggle('open')
            }, [], this )
            .from( this.modal.dimmer, .3, { opacity: 0 } )
            .call( this.content, [], this )
            .from( this.modal.content.container, .35, { opacity: 0, y: -100 } )
    }

    activateListeners() {
        document.querySelectorAll('.insta-grid .item').forEach(
            el => el.addEventListener( 'click', this.handlePostClick.bind(this))
        )
        this.modal.dimmer.addEventListener('click', this.close.bind(this));
        this.modal.closeButton.addEventListener('click', this.close.bind(this));
    }

    handlePostClick( event ) {
        this.post = JSON.parse(event.currentTarget.dataset.post);
        this.open();
    }

    open() {
        this.tl.play();
    }

    content() {
        this.modal.content.image.src = this.post.images.standard_resolution.url;
        this.modal.content.avatar.src = this.post.user.profile_picture;
        this.modal.content.author.href = 'https://instagram.com/'+this.post.user.username;
        this.modal.content.author.innerHTML = this.post.user.full_name;

        if( this.post.caption ) {
            this.modal.content.post.innerHTML = this.post.caption.text;
        }
    }

    removeContent() {
        this.modal.content.image.src = '';
        this.modal.content.avatar.src = '';
        this.modal.content.author.href = '';
        this.modal.content.author.innerHTML = '';
        this.modal.content.post.innerHTML = '';
    }

    close( event ) {
        this.tl.reverse();
    }

}

export default InstagramFeed;